import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Onboarding } from 'app/shared/models/onboarding.model';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { Toast, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-student-onboarding',
  templateUrl: './student-onboarding.component.html',
  styleUrls: ['./student-onboarding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class StudentOnboardingComponent implements OnInit {
  basicForm : FormGroup
  basicForm4 : FormGroup
  basicForm3 : FormGroup
  basicFormSubmitted :boolean = false
  basicFormSubmitted4 :boolean = false
  basicFormSubmitted3 :boolean = false
  activeTab='Step 1'
  onboarding_model:any = new Onboarding;
  user_id:any
  imgUrl:any;
  isEdit: boolean =false;
  fileData: File
  imageBaseUrl = environment.apiUrls.course_imageUrl
  formData = new FormData();
  currentUrl :any
  isOnboarding:boolean =false
  constructor(private ref: ChangeDetectorRef,private formBuilder:FormBuilder,
              private apiService: ApiService,public toastr: ToastrService,
              private activateRoute: ActivatedRoute,private route : Router,
              private cdr : ChangeDetectorRef
              ) {
                this.currentUrl = this.activateRoute.snapshot.routeConfig.path
                this.user_id = JSON.parse(localStorage.getItem('user')).id
                if(this.currentUrl !=='onboarding-form'){
                  this.getAllOnboarding(this.user_id)
                }
                if(this.currentUrl ==='onboarding-form'){
                  this.getAllOnboarding(this.user_id)
                }
  }

  ngOnInit() {
    this.basicForm = this.formBuilder.group({
      about: ['',Validators.required],
    });
    
    this.basicForm3 = this.formBuilder.group({
      resume: ['',Validators.required],
    });
    this.basicForm4 = this.formBuilder.group({
      linkedIn: ['',Validators.required],
    });
  }

  get bf() {
    return this.basicForm.controls;
  }
  get bf4() {
    return this.basicForm4.controls;
  }
  get bf3() {
    return this.basicForm3.controls;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.ref.detectChanges();
    }, 10);

  }
  setActiveTab(tab) {
    this.activeTab = tab;
  }
  onBasicFormSubmit() {
    this.basicFormSubmitted = true;
    if (this.basicForm.invalid) {
      return;
    }
  }
  onBasicFormSubmit4() {
    this.basicFormSubmitted4 = true;
    if (this.basicForm4.invalid) {
      return;
    }
  }
  onBasicFormSubmit3() {
    this.basicFormSubmitted3 = true;
    if (this.basicForm3.invalid) {
      return;
    }
  }
  submit(){
    if(!this.isEdit){
      let body ={
        status: 'pending',
        linkedIn: this.basicForm4.value.linkedIn,
        about: this.basicForm.value.about,
        student_id: this.user_id,
        resume: this.basicForm3.value.resume,
        is_interested: this.onboarding_model.is_interested
      }
      this.apiService.addOnboarding(body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.isOnboarding = true
          this.toastr.success("Onboarding Added Successfully!")
        }
        else this.toastr.error(res.error)
      })
    }
    if(this.isEdit && this.onboarding_model._id){
     
      let body ={
        linkedIn: this.basicForm4.value.linkedIn,
        about: this.basicForm.value.about,
        student_id: this.user_id,
        resume: this.basicForm3.value.resume,
        is_interested: this.onboarding_model.is_interested
      }

      this.apiService.updateOnboarding(this.onboarding_model._id,body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          
          this.isOnboarding = true
          this.route.navigate(['/onboarding'])
          this.toastr.success("Onboarding Updated Successfully!")
        }
        else this.toastr.error(res.error)
      })
    }
  
  }
  onSelectFile(event:any){
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload=(event)=>{
        this.imgUrl = reader.result
      }
    }
  }
  resetFile(){
    this.fileData=null
    this.imgUrl=null
  }
  getAllOnboarding(id){

    if(this.currentUrl ==='onboarding-form'){
      this.apiService.getAllOnboardingByStudent(id).subscribe((res:any)=>{
        this.onboarding_model = res?.data[0]
        if(res?.data.length ===0){
          this.route.navigate(['/onboarding-form'])
          this.onboarding_model = {}
          this.isOnboarding = false
          this.isEdit = false
          this.fileData = null
          this.cdr.detectChanges();
        }
        this.cdr.detectChanges();
      })
    }
    else{
      this.apiService.getAllOnboardingByStudent(id).subscribe((res:any)=>{
          
          this.onboarding_model = res?.data[0]
            this.route.navigate(['/onboarding'])
            this.isOnboarding = true
            this.isEdit = true
            this.cdr.detectChanges();
            if(res?.data.length ===0){
              this.route.navigate(['/onboarding-form'])
              this.onboarding_model = {}
              this.isOnboarding = false
              this.isEdit = false
              this.fileData = null
              this.cdr.detectChanges();
            }
        
      })
    }
    
  }
  asyncTaskValidator(): AsyncValidatorFn {
    return (control) => {
      const value = control.value;

      return new Promise((resolve) => {
        // Simulate an asynchronous validation
        setTimeout(() => {
          if (value && value.trim().length < 50) {
            resolve({ 'notEnoughCharacters': true });
          } else {
            resolve(null); // Validation passed
          }
        }, 1000); // Simulate a delay of 1 second
      });
    };
  }

  minLengthValidator():AsyncValidatorFn  {
    return (control: AbstractControl): Promise<{ [key: string]: any } | null> | Observable<{ [key: string]: any } | null> => {
      const value = control.value;

      return new Promise((resolve) => {
        // Simulate an asynchronous validation
        setTimeout(() => {
          if (value && value.trim().length < 50) {
            resolve({ 'notEnoughCharacters': true });
          } else {
            resolve(null); // Validation passed
          }
        }, 1000); // Simulate a delay of 1 second
      });
    };
  }
  update(data){
    this.route.navigate(['/onboarding-form'])	
    this.isOnboarding = true
    this.cdr.detectChanges();
  }

}
